/* ============================================================
   SP3CTRUM — theme.js
   Scroll nav, size selector, image gallery, AJAX add-to-cart
   ============================================================ */

(function () {
  'use strict';

  /* ─── NAV SCROLL BEHAVIOR ─── */
  const nav = document.getElementById('main-nav');
  if (nav) {
    if (!document.body.classList.contains('template-index')) {
      nav.classList.add('nav-solid');
    }

    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  /* ─── SHARED: CART COUNT ─── */
  // Updates every cart indicator on the page: the nav badge (.cart-count)
  // and any product-page indicator ([data-cart-count]).
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      if (count > 0) { el.classList.add('has-items'); }
      else { el.classList.remove('has-items'); }
    });
  }

  /* ─── SIZE SELECTOR ─── */
  function initSizeSelector() {
    const sizeBtns = document.querySelectorAll('.size-btn:not([disabled])');
    const variantSelect = document.getElementById('variant-select');

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.size-btn:not([disabled])').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');

        if (variantSelect) {
          const selectedSize = btn.dataset.size;
          Array.from(variantSelect.options).forEach(function (opt) {
            if (opt.text.toLowerCase().includes(selectedSize.toLowerCase())) {
              variantSelect.value = opt.value;
            }
          });
        }

        updateCartButton();
      });
    });
  }

  function updateCartButton() {
    const cartBtn = document.querySelector('.btn-add-cart');
    if (!cartBtn) return;
    const activeSize = document.querySelector('.size-btn.active');
    if (activeSize) {
      cartBtn.removeAttribute('disabled');
      cartBtn.textContent = 'Add to Cart';
    }
  }

  /* ─── PRODUCT IMAGE GALLERY ─── */
  function initImageGallery() {
    const mainImage = document.querySelector('.product-main-image');
    const thumbnails = document.querySelectorAll('.product-thumbnails img');
    const prevBtn = document.getElementById('gallery-prev');
    const nextBtn = document.getElementById('gallery-next');

    if (!mainImage) return;

    const images = Array.from(thumbnails);
    let currentIndex = 0;

    function goToImage(index) {
      if (!images.length) return;
      currentIndex = ((index % images.length) + images.length) % images.length;
      const target = images[currentIndex];
      mainImage.src = target.dataset.full || target.src;
      mainImage.alt = target.alt;
      images.forEach(function (t) { t.classList.remove('active'); });
      target.classList.add('active');
    }

    images.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goToImage(i); });
    });

    if (images.length) goToImage(0);

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goToImage(currentIndex - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goToImage(currentIndex + 1); });
    }

    var touchStartX = 0;
    var touchEndX = 0;
    mainImage.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    mainImage.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          goToImage(currentIndex + 1);
        } else {
          goToImage(currentIndex - 1);
        }
      }
    }, { passive: true });
  }

  /* ─── CART QUANTITY CONTROLS ─── */
  function initCartQuantity() {
    document.querySelectorAll('.qty-decrease').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const lineItem = btn.closest('[data-line-item]');
        if (!lineItem) return;
        const qtyDisplay = lineItem.querySelector('.cart-item-qty span');
        let qty = parseInt(qtyDisplay.textContent, 10) || 1;
        if (qty > 1) {
          qty -= 1;
          qtyDisplay.textContent = qty;
          updateCartLineItem(lineItem.dataset.lineItem, qty);
        }
      });
    });

    document.querySelectorAll('.qty-increase').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const lineItem = btn.closest('[data-line-item]');
        if (!lineItem) return;
        const qtyDisplay = lineItem.querySelector('.cart-item-qty span');
        let qty = parseInt(qtyDisplay.textContent, 10) || 1;
        qty += 1;
        qtyDisplay.textContent = qty;
        updateCartLineItem(lineItem.dataset.lineItem, qty);
      });
    });
  }

  function updateCartLineItem(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.item_count !== undefined) updateCartCount(data.item_count);
    })
    .catch(function (err) { console.error('Cart update error:', err); });
  }

  /* ─── MOBILE NAV HAMBURGER ─── */
  function initHamburger() {
    var btn = document.getElementById('nav-hamburger');
    var drawer = document.getElementById('mobile-nav');
    if (!btn || !drawer) return;

    function openMenu() {
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    var closeBtn = drawer.querySelector('.mobile-nav-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ─── PRODUCT FORM: VALIDATE + AJAX ADD ───
     Validates a size is chosen, then adds via /cart/add.js so the customer
     stays on the product page. Critical for Unlisted products, which have no
     nav path back once Shopify's default redirect drops them on /cart. */
  var ADD_BTN_LABEL = 'Add to Cart';
  var addRevertTimer = null;

  function initVariantValidation() {
    var form = document.getElementById('product-form');
    if (!form) return;

    // Capture once, before any click, so a rapid second add never inherits
    // "Added" as its restore label.
    var initialBtn = form.querySelector('.btn-add-cart');
    if (initialBtn && initialBtn.textContent.trim()) {
      ADD_BTN_LABEL = initialBtn.textContent.trim();
    }

    form.addEventListener('submit', function (e) {
      var sizeBtns = form.querySelectorAll('.size-btn');
      if (sizeBtns.length > 0) {
        var hasSelected = form.querySelector('.size-btn.active:not(.out-of-stock):not([disabled])');
        if (!hasSelected) {
          e.preventDefault();
          showVariantError('Please select a size before adding to cart.');
          return false;
        }
      }
      var errorEl = document.querySelector('.variant-error');
      if (errorEl) errorEl.style.display = 'none';

      // Stay on the page — add through the Cart AJAX API instead of posting.
      // If this throws before preventDefault, the form still posts normally and
      // the return_to hidden field keeps the customer on the product page.
      e.preventDefault();
      addToCartAjax(form);
    });
  }

  // Adds are queued and run in order. The button is never disabled, so a
  // customer adding sizes back to back can never have a tap silently dropped
  // while a previous request is still in flight.
  var addChain = Promise.resolve();

  function addToCartAjax(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      showVariantError('Please select a size before adding to cart.');
      return;
    }
    var qtyInput = form.querySelector('[name="quantity"]');
    // capture now — the selection may change before this add is processed
    var id = idInput.value;
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    addChain = addChain.then(function () { return runAdd(form, id, quantity); });
  }

  function runAdd(form, variantId, quantity) {
    var btn = form.querySelector('.btn-add-cart') || form.querySelector('[type="submit"]');

    if (btn) { btn.textContent = 'Adding…'; }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    })
    .then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
        return data;
      });
    })
    .then(function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      if (btn) {
        btn.textContent = 'Added ✓';
        clearTimeout(addRevertTimer);
        addRevertTimer = setTimeout(function () { btn.textContent = ADD_BTN_LABEL; }, 1200);
      }
    })
    .catch(function (err) {
      showVariantError(err.message || 'Could not add to cart.');
      if (btn) { btn.textContent = ADD_BTN_LABEL; }
    });
  }

  function showVariantError(message) {
    var errorEl = document.querySelector('.variant-error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'variant-error';
      var addBtn = document.querySelector('.btn-add-cart');
      if (addBtn) addBtn.parentNode.insertBefore(errorEl, addBtn);
    }
    errorEl.textContent = message;
    errorEl.style.display = 'block';
    setTimeout(function () { errorEl.style.display = 'none'; }, 4000);
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ─── INIT ON DOM READY ─── */
  document.addEventListener('DOMContentLoaded', function () {
    initHamburger();
    initSizeSelector();
    initVariantValidation();
    initImageGallery();
    initCartQuantity();
  });

})();
